/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ResyncOutcome {
  Resynced = "Resynced",
  Skipped = "Skipped",
  Failed = "Failed",
}

export function instanceOfResyncOutcome(value: any): boolean {
  for (const key in ResyncOutcome) {
    if (Object.prototype.hasOwnProperty.call(ResyncOutcome, key)) {
      if (ResyncOutcome[key as keyof typeof ResyncOutcome] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ResyncOutcomeFromJSON(json: any): ResyncOutcome {
  return ResyncOutcomeFromJSONTyped(json, false);
}

export function ResyncOutcomeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResyncOutcome {
  return json as ResyncOutcome;
}

export function ResyncOutcomeToJSON(value?: ResyncOutcome | null): any {
  return value as any;
}

export function ResyncOutcomeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResyncOutcome {
  return value as ResyncOutcome;
}
